import { render } from "./PdfTemplate.vue?vue&type=template&id=63817fdc&scoped=true"
import script from "./PdfTemplate.vue?vue&type=script&lang=js"
export * from "./PdfTemplate.vue?vue&type=script&lang=js"

import "./PdfTemplate.vue?vue&type=style&index=0&id=63817fdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63817fdc"]])

export default __exports__